import { Filter } from "../models/Filter";
import { ObjectField } from "../models/ObjectField";
import { FilterControl } from "../models/FilterControl";
import { FilterOperator } from "../models/FilterOperator";

export class FilterColumn {
    Id: string;
    Filter: Filter;
    Control: FilterControl;
    Operators: FilterOperator[];
    Label: string | null;
    Data: any;
    ObjectField: ObjectField;
}